import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  UserNotificationSourceKind,
  UserNotificationTargetRouteKey,
} from '@automatick/shared-ts';
import { UserNotificationResponse } from '@automatick/shared-ng';
import { IconsNgModule } from '@seech/icons-ng';
import { UserNotificationService } from '../../services';

@Component({
  selector: 'app-notification-cards',
  standalone: true,
  imports: [AsyncPipe, IconsNgModule, NgClass],
  templateUrl: './notification-cards.component.html',
  styleUrl: './notification-cards.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationCardsComponent {
  private readonly notificationService = inject(UserNotificationService);
  private readonly router = inject(Router);

  readonly cards$ = this.notificationService.browserCards$;

  onOpen(notification: UserNotificationResponse): void {
    const notificationId = notification.notificationId;
    const conversationAction = notification.actions?.find(
      (action) =>
        action.targetRouteKey === UserNotificationTargetRouteKey.Conversation &&
        !!action.targetEntityId,
    );
    const workRequestAction = notification.actions?.find(
      (action) =>
        action.targetRouteKey === UserNotificationTargetRouteKey.WorkRequest &&
        !!action.targetEntityId,
    );

    if (
      conversationAction?.targetEntityId ||
      (notification.sourceKind === UserNotificationSourceKind.Conversation &&
        notification.sourceId)
    ) {
      this.router.navigate([
        '/chat',
        conversationAction?.targetEntityId || notification.sourceId,
      ]);
    } else if (workRequestAction?.targetEntityId) {
      this.router.navigate(['/work-requests'], {
        queryParams: { itemId: workRequestAction.targetEntityId },
      });
    } else {
      this.router.navigate(['/notifications']);
    }

    this.notificationService.markRead(notification);
    this.notificationService.dismissBrowserCard(notificationId);
  }

  onDismiss(notification: UserNotificationResponse, event: Event): void {
    event.stopPropagation();
    this.notificationService.dismissBrowserCard(notification.notificationId);
  }

  getTone(notification: UserNotificationResponse): string {
    return (notification.severity || 'Info').toLowerCase();
  }
}
